export const PERCENTAGE_MIN = 0;
export const PERCENTAGE_MAX = 100;
export const DECIMAL_PRECISION = 100;

export const ROUNDING_MAGNITUDE_THRESHOLDS = {
  VERY_LARGE: 10000,
  LARGE: 5000,
  MEDIUM: 1000,
  SMALL: 100,
  TINY: 10,
} as const;

export const ROUNDING_INCREMENTS = {
  VERY_LARGE: 1000,
  LARGE: 500,
  MEDIUM: 100,
  SMALL: 10,
  TINY: 5,
  MINIMAL: 1,
} as const;

export const LABEL_COUNT = {
  MIN: 8,
  MAX: 12,
  BASE: 6,
  SCALE_FACTOR: 2,
} as const;

export const DEFAULT_LABEL_COUNT_CONFIG = {
  fixed: undefined as number | undefined,
  min: LABEL_COUNT.MIN,
  max: LABEL_COUNT.MAX,
  base: LABEL_COUNT.BASE,
  scaleFactor: LABEL_COUNT.SCALE_FACTOR,
};

export const DISTANCE_THRESHOLDS = {
  LARGE_RANGE: 6,
  SMALL_RANGE: 7,
  LARGE_RANGE_BOUNDARY: 1000,
} as const;

export const INFINITY_SYMBOLS = ['∞', 'infinity'] as const;

export const Z_INDEX = {
  SLIDER: 10,
  TOOLTIP: 20,
} as const;
